const phoneCheckReducer  = (state = { orders: [] } , action)=>{
    switch(action.type){
        case "phoneCheck": 
        console.log("phoneCheckReducer = ",action)
        return {...state, orders: action?.payload};
        default: return state;
    }
}


export default phoneCheckReducer